export default {
  name: 'DossierOverviewTableInputProduct',
  components: {},
  props: {
    productObj: {},
  },
  data: () => ({
    cargoInputs: [],
    samplingInputs: [],
    analysisInputs: [],
    inspectionInputs: [],
    showInputLog: false,
    logInputs: [],
    logTitle: '',
    logHeaders: [
      { text: 'Job date', value: 'jobDate' },
      { text: 'Created', value: 'created' },
      { text: 'ET start', value: 'beginEstimate' },
      { text: 'AT start', value: 'beginActual' },
      { text: 'ET end', value: 'endEstimate' },
      { text: 'AT end', value: 'endActual' },
      { text: '', value: 'buttons' },
    ],
  }),
  computed: {},
  methods: {
    sortInputs() {
      this.productObj.inputs.forEach((input) => {
        switch (input.inputType) {
          case 'CargoOperations':
            this.cargoInputs.push(input);
            break;
          case 'Sampling':
            this.samplingInputs.push(input);
            break;
          case 'Analysis':
            this.analysisInputs.push(input);
            break;
          case 'Inspection':
            this.inspectionInputs.push(input);
            break;
          default:
            break;
        }
      });
    },
    goToDetail(input) {
      const routeData = this.$router.resolve({ name: 'input-form-with-id', params: { id: input.inputId } });
      window.open(routeData.href, '_blank');
    },
    addToDossier(type) {
      const routeData = this.$router.resolve({ name: 'input-form', query: { dossierId: this.productObj.dossierId, type, client: this.productObj.clientId } });
      window.open(routeData.href, '_blank');
    },
    toggleInputLog(inputs, title) {
      this.showInputLog = true;
      this.logInputs = inputs;
      this.logTitle = title;
    },
  },
  mounted() {
    this.sortInputs();
  },
};
